import { oc } from '@orpc/contract';
import { listEstimateActivityInputSchema, listEstimateActivityOutputSchema } from '../schemas/estimates.schemas.js';
/** The append-only history of one estimate, newest first (plan §4 `activity_events`). */
export const listEstimateActivityContract = oc
    .route({
    method: 'GET',
    path: '/estimates/{estimateId}/activity',
    tags: ['Estimates'],
    summary: 'List an estimate’s activity',
})
    .input(listEstimateActivityInputSchema)
    .output(listEstimateActivityOutputSchema);
//# sourceMappingURL=list-estimate-activity.contract.js.map